"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18next = require("i18next");
var i18nextXHRBackend = require("i18next-xhr-backend");
/* TODO we should load languages async */
var SUPPORTED_LANGUAGES = [
    'ar', 'bg', 'cs', 'da', 'de', 'el', 'en',
    'es', 'fi', 'fr', 'he', 'hi', 'hu', 'id',
    'it', 'ja', 'ko', 'ms', 'nl', 'no', 'pl',
    'pt', 'ro', 'ru', 'sv', 'th', 'tl', 'tr',
    'zh',
];
exports.init = function (_a) {
    var locale = _a.locale;
    var resources = {};
    SUPPORTED_LANGUAGES.forEach(function (lng) {
        resources[lng] = {
            translation: require("./assets/locale/messages_" + lng + ".json"),
        };
    });
    return new Promise(function (resolve) {
        return i18next
            .use(i18nextXHRBackend)
            .init({
            resources: resources,
            lng: locale,
            keySeparator: '$',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false,
            },
        }, resolve);
    });
};
exports.default = i18next;
//# sourceMappingURL=i18n.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/i18n.js
// module id = 36
// module chunks = 0 1